/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Loader/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Loader({
  children,
  viewPath = "/DesignSystem/VideoCapture/Content/CaptureFeed/Content/Loader"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Loader.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
/>
{children}
</React.Fragment>)
}